import { render, staticRenderFns } from "./coreMessage.vue?vue&type=template&id=1b9514e2&scoped=true"
import script from "./coreMessage.vue?vue&type=script&lang=js"
export * from "./coreMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9514e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b9514e2')) {
      api.createRecord('1b9514e2', component.options)
    } else {
      api.reload('1b9514e2', component.options)
    }
    module.hot.accept("./coreMessage.vue?vue&type=template&id=1b9514e2&scoped=true", function () {
      api.rerender('1b9514e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeKanban/components/coreMessage.vue"
export default component.exports